import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Credentials|Continuing Education|Progress|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.CredentialContinuingEducationCeProgress,
	portal: 'CP',
};
const columnHeadingDescriptionStart = 'Column heading for: ';

export type CPCandidateCeProgressLocNames =
	| `CPCandidateCeProgressLabelStatus`
	| `CPCandidateCeProgressLabelCycleStartDate`
	| `CPCandidateCeProgressLabelCycleDaysRemaining`;

export const cpCandidateCeProgressLocs: LocDefs<CPCandidateCeProgressLocNames> = {
	CPCandidateCeProgressLabelStatus: {
		defaultValue: 'Status',
		description: `${columnHeadingDescriptionStart}Status.`,
		displayPath: `${pathStart}Status`,
		displayType: 'Title',
		...sharedProperties,
	},
	CPCandidateCeProgressLabelCycleStartDate: {
		defaultValue: 'Cycle Start Date',
		description: `${columnHeadingDescriptionStart}Cycle Start Date.`,
		displayPath: `${pathStart}Cycle Start Date`,
		displayType: 'Label',
		...sharedProperties,
	},
	CPCandidateCeProgressLabelCycleDaysRemaining: {
		defaultValue: 'Cycle Days Remaining',
		description: `${columnHeadingDescriptionStart}Cycle Days Remaining.`,
		displayPath: `${pathStart}Cycle Days Remaining`,
		displayType: 'Label',
		...sharedProperties,
	},
};

export type CPCandidateCeProgressLocType = LocMap<CPCandidateCeProgressLocNames>;
